function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.729 1.2 3.346 6.629 6.44.638a.805.805 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-1.151.935L12 19.934l-6.52 3.229a.813.813 0 0 1-1.151-.935l1.965-7.138L.99 9.837a.805.805 0 0 1 .5-1.374l6.44-.638L11.271 1.2a.819.819 0 0 1 1.458 0Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.71e4deac31e899e19e695e3d54be4403.svg";
export { ForwardRef as ReactComponent };